import type { SerializedStyles } from '@emotion/react'
import { css } from '@emotion/react'

import { breakpoint, size } from '@twisto/styles'

import type { Variant } from '../list.context'

export const root = css`
  display: grid;
  grid-template-columns: max-content 1fr;
  align-items: flex-start;
`

export const gap = css`
  column-gap: ${size[12]};

  ${breakpoint.down('sm')} {
    column-gap: ${size[8]};
  }
`

export const iconWrapper: Record<Variant, SerializedStyles> = {
  medium: css`
    line-height: 0;
    width: ${size[24]};
    height: ${size[24]};

    ${breakpoint.down('sm')} {
      width: ${size[20]};
      height: ${size[20]};
    }
  `,
  small: css`
    line-height: 0;
    width: ${size[20]};
    height: ${size[20]};

    ${breakpoint.down('sm')} {
      width: ${size[16]};
      height: ${size[16]};
    }
  `,
}
